import { useLayoutEffect, type RefObject } from 'react';

/**
 * O RETORNO DE AÇÃO PRECISA FICAR POR CIMA DA FOLHA E DA JANELA ABERTAS.
 *
 * A folha, a janela e a gaveta são `<dialog>` com `showModal()`: vão para a
 * CAMADA DE CIMA do navegador, acima de qualquer `z-index` da página. O toast
 * da recusa que nascia com uma folha aberta ficava por baixo do fundo
 * escurecido, e a pessoa não via por que nada acontecia (achado em 05/10).
 *
 * O contêiner dos retornos vira um `popover="manual"` — que também mora na
 * camada de cima — e, a cada retorno novo, sai e entra de novo: o último a
 * entrar fica por cima, então o toast passa à frente do que estiver aberto.
 * Sem suporte a popover, nada muda (o `z-index` de antes continua valendo).
 */
export function useNaCamadaDeCima(ref: RefObject<HTMLElement | null>, chave: string | undefined): void {
  useLayoutEffect(() => {
    const el = ref.current as (HTMLElement & { showPopover?: () => void; hidePopover?: () => void }) | null;
    if (!el || typeof el.showPopover !== 'function' || typeof el.hidePopover !== 'function') return;
    if (!el.hasAttribute('popover')) el.setAttribute('popover', 'manual');
    try {
      if (el.matches(':popover-open')) el.hidePopover();
      el.showPopover();
    } catch {
      /* navegador sem a camada de cima: fica como estava */
    }
  }, [ref, chave]);
}
